import { useDispatch } from 'react-redux';
import store from '../../store';

export type ThunkDispatch = typeof store.dispatch;
export const useThunkDispatch = () => useDispatch<ThunkDispatch>();

export default useThunkDispatch;
